import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';

import { Box } from '@mui/material';
import useRewriteAtlasLinks from './useRewriteAtlasLinks';
import useWebsiteSports, { SportProviders } from 'store/websiteSports';

const atlasWidgetContainer = 'atlas-widget';
const atlasScriptId = 'atlas-script';

declare global {
  const AtlasSDK: {
    initialize: (config: { siteRoot: string; projectId: string | number; apiRoot: string }) => void;
    renderWidget: (element: HTMLElement, widgetType: string, options: { timeout: number }) => void;
    widgets: {
      TOP_EVENTS: string;
    };
  };
}

const AtlasWidget = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const atlasWidgetRef = useRef<HTMLDivElement | null>(null);
  const [state] = useWebsiteSports();

  const atlasSport = state?.data.find((sport) => sport.id === SportProviders.ATLAS_ID);

  const handleClientChanges = (_, { scriptTags }) => {
    if (scriptTags) {
      const atlasScript = document.getElementById(atlasScriptId);
      atlasScript?.addEventListener('load', () => {
        setIsLoaded(true);
      });
    }
  };

  useRewriteAtlasLinks(atlasWidgetRef);

  useEffect(() => {
    if (!isLoaded || !state?.data.length) return;

    AtlasSDK.initialize({
      siteRoot: window.location.hostname,
      projectId: atlasSport.meta,
      apiRoot: 'https://widget.pl-01.play-platform.com',
    });
    try {
      AtlasSDK.renderWidget(document.getElementById(atlasWidgetContainer), AtlasSDK.widgets.TOP_EVENTS, {
        timeout: 6000,
      });
    } catch {
      //   console.error(err);
    }
  }, [isLoaded, state]);

  return (
    <Box mt={2}>
      <Helmet onChangeClientState={handleClientChanges}>
        <link href="https://static-widget.pl-01.play-platform.com/public/sdk.css" rel="stylesheet" />
        <script
          id={atlasScriptId}
          src="https://static-widget.pl-01.play-platform.com/public/sdk.js"
          onLoad={() => setIsLoaded(true)}
        ></script>
      </Helmet>
      <div id={atlasWidgetContainer} ref={atlasWidgetRef} />
    </Box>
  );
};

export default AtlasWidget;
